import React from "react";

import { createFileCacheDB, FilesDB } from "@components/cache/db";

const filesDB = createFileCacheDB();

const Context = React.createContext<{
  files: FilesDB;
}>({
  files: filesDB,
});

function useFilesCache() {
  return React.useContext(Context).files;
}

function Cache({ children }: { children: React.ReactNode }) {
  return (
    <Context.Provider
      value={{
        files: filesDB,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export { Cache, useFilesCache };
